import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ContentCardMiniReadonlyModule } from '@app/collections/shared/content-card-mini-readonly/content-card-mini-readonly.module';
import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { PipesModule } from '@core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { OnUiButtonModule } from 'onclass-ui';
import { ContentCarouselComponent } from './content-carousel/content-carousel.component';
import { ContentSelectorComponent } from './content-selector.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SpinnersModule,
    FormsModule,
    PipesModule,
    RouterModule,
    ContentCardMiniReadonlyModule,
    ModalModule,
    OnUiButtonModule,
    ContentCardModule,
    IconComponent,
  ],
  declarations: [ContentCarouselComponent, ContentSelectorComponent],
  exports: [ContentSelectorComponent],
})
export class ContentSelectorModule {}
